import { useEffect, useState } from "react";
import { Keyboard } from "react-native";

export const usePdpKeyboardState = () => {
  const [isKeyboardVisible, setKeyboardVisible] = useState(false);
  const [isMultilineFocused, setIsMultilineFocused] = useState(false);

  useEffect(() => {
    const showListener = Keyboard.addListener("keyboardDidShow", () => {
      setKeyboardVisible(true);
    });

    const hideListener = Keyboard.addListener("keyboardDidHide", () => {
      setKeyboardVisible(false);
    });

    return () => {
      showListener.remove();
      hideListener.remove();
    };
  }, []);

  return {
    isKeyboardVisible,
    setKeyboardVisible,
    isMultilineFocused,
    setIsMultilineFocused,
  };
};
